__turbopack_context__.v({
  "component": "style-module-scss-module__-1Ic9W__component",
  "icon": "style-module-scss-module__-1Ic9W__icon",
  "pill": "style-module-scss-module__-1Ic9W__pill",
});
